// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as SupCharms from "../set-update/SupCharms.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function CharmsPage$OddsRow(Props) {
  var stage = Props.stage;
  var odds = Props.odds;
  var bg = Props.bg;
  return React.createElement("div", {
              className: "flex p-3 sm:p-4 text-xs sm:text-base font-montserrat font-medium" + (
                bg ? " bg-bg2" : ""
              )
            }, React.createElement("div", {
                  className: "w-[56px] sm:w-20 text-center"
                }, "Stage " + (
                  stage === "6" ? "6+" : stage
                )), React.createElement("div", {
                  className: "w-[56px] sm:w-24 text-right"
                }, T.formatPct2(odds[1])), React.createElement("div", {
                  className: "w-[56px] sm:w-24 text-right"
                }, T.formatPct2(odds[2])), React.createElement("div", {
                  className: "w-[56px] sm:w-24 text-right"
                }, T.formatPct2(odds["2_5"])), React.createElement("div", {
                  className: "w-[56px] sm:w-24 text-right"
                }, T.formatPct2(odds[3])), React.createElement("div", {
                  className: "w-[56px] sm:w-24 text-right"
                }, T.formatPct2(odds[4])));
}

var OddsRow = {
  make: CharmsPage$OddsRow
};

function make(charms, charmOdds) {
  var cs = charms.charms;
  var charmOdds$1 = charms.charmOdds;
  return React.createElement("div", {
              className: "flex flex-col items-center"
            }, React.createElement("div", {
                  className: "bg-bg mt-8"
                }, React.createElement("div", {
                      className: "flex p-3 sm:p-4 text-xs sm:text-base font-montserrat font-medium"
                    }, React.createElement("div", {
                          className: "w-[56px] sm:w-20 text-center"
                        }, ""), React.createElement("div", {
                          className: "w-[56px] sm:w-24 text-right"
                        }, "Tier 1"), React.createElement("div", {
                          className: "w-[56px] sm:w-24 text-right"
                        }, "Tier 2"), React.createElement("div", {
                          className: "w-[56px] sm:w-24 text-right"
                        }, "Tier 2.5"), React.createElement("div", {
                          className: "w-[56px] sm:w-24 text-right"
                        }, "Tier 3"), React.createElement("div", {
                          className: "w-[56px] sm:w-24 text-right"
                        }, "Tier 4")), Belt_Array.mapWithIndex(Js_dict.entries(charmOdds$1.base), (function (idx, param) {
                        var key = param[0];
                        return React.createElement(CharmsPage$OddsRow, {
                                    stage: key,
                                    odds: param[1],
                                    bg: idx % 2 === 0,
                                    key: key
                                  });
                      }))), React.createElement(SupCharms.CharmsGroup.make, {
                  charms: Belt_Array.keep(cs, (function (charm) {
                          return charm.tier === "1";
                        })),
                  tier: 1
                }), React.createElement(SupCharms.CharmsGroup.make, {
                  charms: Belt_Array.keep(cs, (function (charm) {
                          return charm.tier === "2";
                        })),
                  tier: 2
                }), React.createElement(SupCharms.CharmsGroup.make, {
                  charms: Belt_Array.keep(cs, (function (charm) {
                          return charm.tier === "2_5";
                        })),
                  tier: 25
                }), React.createElement(SupCharms.CharmsGroup.make, {
                  charms: Belt_Array.keep(cs, (function (charm) {
                          return charm.tier === "3";
                        })),
                  tier: 3
                }), React.createElement(SupCharms.CharmsGroup.make, {
                  charms: Belt_Array.keep(cs, (function (charm) {
                          return charm.tier === "4";
                        })),
                  tier: 4
                }), React.createElement(SupCharms.CharmsGroup.make, {
                  charms: Belt_Array.keep(cs, (function (charm) {
                          return charm.tier === "9";
                        })),
                  tier: 9
                }), React.createElement(SupCharms.CharmsGroup.make, {
                  charms: Belt_Array.keep(cs, (function (charm) {
                          return charm.tier === "99";
                        })),
                  tier: 99
                }));
}

export {
  OddsRow ,
  make ,
  
}
/* T Not a pure module */
